import type IProduct from "@api/models/IProduct";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Icon from "@core-components/icon/Icon";
import type { AppRegion } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Text } from "@mantine/core";

interface ISkinProductSummaryProps {
  selectedProduct: IProduct | undefined;
  isOutOfStock: boolean;
  region: AppRegion;
  handleOnBuy: () => void;
}

export const SkinProductSummary: React.FC<ISkinProductSummaryProps> = ({
  selectedProduct,
  isOutOfStock,
  handleOnBuy,
  region,
}) => {
  const productT = useAppTranslation();

  return (
    <>
      {selectedProduct && (
        <Text className="font-secret-black text-[12px] text-secondary-500">
          <Icon.Share size={30} />
          {`${productT.t(`${selectedProduct.i18nKey}.tagline`)} - ${region}`}
        </Text>
      )}

      <Text className="font-bold text-[30px] text-primary-white">
        {selectedProduct && `${selectedProduct?.price} €`}
      </Text>

      <ButtonVariants.BuyNow outOfStock={isOutOfStock} onClick={handleOnBuy} />
    </>
  );
};
